import React from 'react';
import { useTranslation } from 'react-i18next';
import logo from "../assets/img/variatel-logo-6369473e.png"

const Header = () => {
  const { t, i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <header style={{ paddingBottom: '16px', background: '#f5f5f5' }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div style={{ textAlign: 'left',     height: '60px' }}><img src={logo} alt="logo" className='nav-logo'/></div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
          <a href="/contact" style={{ textDecoration: 'none', color: '#333', fontWeight: '500' }}>
            {t('contact') || 'Contact'}
          </a>
          <select
            onChange={e => changeLanguage(e.target.value)}
            value={i18n.language}
            style={{ padding: '6px', borderRadius: '4px' }}
          >
            <option value="en">English</option>
            <option value="de">Deutsch</option>
          </select>
        </div>
      </div>
    </header>
  );
};

const Footer = () => (
  <footer style={{ padding: '12px', background: '#f5f5f5', textAlign: 'center', marginTop: '40px' }}>
    <small>&copy; {new Date().getFullYear()} Variatel. All rights reserved.</small>
  </footer>
);

const AuthLayout = ({ children }) => (
  <div>
    <Header />
    <main style={{ minHeight: '70vh' }}>{children}</main>
    <Footer />
  </div>
);

export default AuthLayout;